import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasEmpleadoprestamosComponent (FinanzasEmpleadoprestamos) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.buscar = buscar
  $ctrl.seleccionar = seleccionar

  function $onInit () {
    $ctrl.data = undefined
    $ctrl.busqueda = undefined
    $ctrl.buscando = false
    $ctrl.empleado = undefined
  }

  function buscar () {
    var buscar = $ctrl.busqueda ? $ctrl.busqueda.trim() : ''
    if (buscar === '' || buscar.length < 3) {
      $ctrl.data = undefined
      return
    }

    $ctrl.buscando = true
    FinanzasEmpleadoprestamos.getEmpleados(buscar).then(function (response) {
      $ctrl.data = response.data
      $ctrl.buscando = false;
    });
  }

  function seleccionar (data) {
    $ctrl.empleado = data;
  }
}

module.component('finanzasEmpleadoprestamos', {
  controller: FinanzasEmpleadoprestamosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/components/component.js